import {
  GARLIC_CRUST_SEASONING_CODE,
  NO_CRUST_SEASONING_OPTION,
  PARMESAN_CRUST_SEASONING_CODE,
  PARMESAN_GARLIC_CRUST_SEASONING_OPTION,
} from "constants/crustSeasonings";
import { AREAS } from "constants/order";
import RESOURCE_TYPE from "constants/resource";

const filterToppings =
  (codes) =>
  ({ code }) =>
    !codes.includes(code);

export const getOrderProductSeasoningBody = ({
  seasonings,
  seasoningOptionCode,
  baseCode,
  parts,
  itemQuantity,
  sizeCode,
  cookingInstructions,
} = {}) => {
  const seasoningCodes = seasonings.map((seasoning) => seasoning.toppingCode);

  // filter all seasonings out
  parts[AREAS.WHOLE].options = parts[AREAS.WHOLE].options.filter(
    filterToppings(seasoningCodes)
  );

  parts[AREAS.WHOLE].options.push({
    code: GARLIC_CRUST_SEASONING_CODE,
    weight: seasoningOptionCode === NO_CRUST_SEASONING_OPTION ? 0 : 1,
  });

  const hasParmesanSeasoning = seasoningCodes.includes(
    PARMESAN_CRUST_SEASONING_CODE
  );
  if (hasParmesanSeasoning) {
    parts[AREAS.WHOLE].options.push({
      code: PARMESAN_CRUST_SEASONING_CODE,
      weight:
        seasoningOptionCode === PARMESAN_GARLIC_CRUST_SEASONING_OPTION ? 1 : 0,
    });
  }

  return {
    data: {
      type: RESOURCE_TYPE.PRODUCT,
      attributes: {
        base: baseCode,
        cookingInstructions,
        parts,
        quantity: itemQuantity,
        sizeCode,
      },
    },
  };
};
